import { getDocumentsWeb } from "@/pages/asset-details/repositories/AssetDetailsRepositorie";
import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { get } from "lodash-es";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchDrawings = ({ setIsLoading, setError }: Props) => {
	const {
		actions: { setListAllDrawings },
	} = useTemplatesContext();

	return async (drawingSearch?: string) => {
		setIsLoading(true);
		const res = await getDocumentsWeb(drawingSearch || null);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setListAllDrawings(rowsSource);
			setIsLoading(false);
		} else {
			setIsLoading(false);
			setError(res.message);
		}
	};
};
